import { parentHuntLocationToTract } from './clubBoundaryRole';

export function mapClubFeatureToEndpoint(feature) {
  if (!feature || !feature.id) {
    throw new Error('Invalid feature');
  }
  const idStr = String(feature.id);
  const isBoundary = feature.featureType === 'hunt_boundary' || idStr.startsWith('boundary-');
  const isClubLine = feature.featureType === 'club_line' || idStr.startsWith('clubline-');
  const numericId = parseInt(
    idStr
      .replace('boundary-', '')
      .replace('location-', '')
      .replace('clubline-', ''),
    10
  );
  if (Number.isNaN(numericId)) {
    throw new Error('Invalid feature id');
  }
  if (isBoundary) {
    return { path: `/hunt-boundaries/${numericId}/`, kind: 'boundary', id: numericId };
  }
  if (isClubLine) {
    return { path: `/features/${numericId}/`, kind: 'club_line', id: numericId };
  }
  return { path: `/hunt-locations/${numericId}/`, kind: 'location', id: numericId };
}

/** Numeric hunt-location id from a club map feature (`location-34` or a bare id). */
export function clubHuntLocationNumericId(feature) {
  try {
    const mapped = mapClubFeatureToEndpoint(feature);
    return mapped.kind === 'location' ? mapped.id : null;
  } catch {
    return null;
  }
}

/**
 * Board rows / feeder cards are raw hunt locations (numeric id).
 * MarkerModal edit needs the same `location-` feature shape as the map.
 */
export function clubBoardLocationAsEditFeature(location) {
  const loc = location?.location && location.location.id != null
    ? location.location
    : location;
  if (loc == null || loc.id == null) return null;
  const numericId = Number(loc.id);
  if (!Number.isFinite(numericId)) return null;
  return {
    ...loc,
    id: `location-${numericId}`,
    featureType: 'hunt_location',
    isHuntLocation: true,
    type: 'point',
    geojson: loc.geojson,
  };
}

/** PATCH body when a president drags a club pin. Re-parents to the tract under the new point. */
export function clubWaypointMovePayload(geometry, tracts) {
  const tract = parentHuntLocationToTract(geometry, tracts);
  if (!tract) {
    return null;
  }
  return {
    geojson: geometry,
    hunt_boundary: tract.id,
  };
}


